// extracted by mini-css-extract-plugin
export default {"view":"S3anDG1_0S9x8rBJOSHZ","panelFill":"ejCkNnN_u1dCvXjF_IxN"};